// import { Icon } from "@iconify/react/dist/iconify.js";
import { Box } from "@mui/material";
import pointBadge from '../../assets/customicons/pointBadge.png';

export default function PointIcon({ size=20 }) {
    return (
        <span>
        <Box className="centered-container" sx={{
            borderRadius: '50%',
            height: '100%'
        }}>
            <img src={pointBadge} style={{ width: size }} alt="point icon" />
        </Box>
        </span>
    )
}